<template>
  <div :class="$style.pay">
    <h1>
      <img :src="`${$cdnUrl}/tgStore/xiangzuo.png`" alt="" @click="$router.go(-1)">
      <span>支付</span>
    </h1>
    <div :class="$style.price">
      <p>支付金额</p>
      <p :class="$style.priceNum">
        ￥<span>{{ goodsInfo.price }}</span>
      </p>
    </div>
    <div :class="$style.info">
      <p>
        游戏：<span>{{ gameInfo.name }}</span>
      </p>
      <p>
        区服：<span :class="$style.server">{{ userInfo.server }}</span>
      </p>
      <p>
        角色：<span>{{ userInfo.role }}</span>
      </p>
      <p>
        购买道具：<span  :class="$style.product">{{ goodsInfo.name }}</span>
      </p>
    </div>
    <div :class="$style.payType">
      <p>请选择支付方式</p>
      <ul>
        <li v-for="(item, index) in payType" :key="index" @click="currentPayType = item">
          <img :src="item.img_class_name == 'wechat' ? wxIcon: zfbIcon " alt="" :class="$style.icon">
          <span>{{ item.unite_name }}</span>
          <img :class="$style.check" :src="currentPayType.pay_type === item.pay_type ? `${$cdnUrl}/tgStore/check.png` : `${$cdnUrl}/tgStore/uncheck.png`" alt="">
        </li>
      </ul>
    </div>
    <button :class="$style.submit" @click="createOrder">立即支付</button>
    <div :class="$style.hint" v-show="hintShow" @click="hintShow = false"></div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { payType, createOrder, officialAccountsPay, checkOrder as checkOrderApi } from '@/api/tgStore';
import { isWeiXin } from '@/utils';
import { sort_ASCII } from '@/utils/index';

export default {
  name: '',
  data() {
    return {
      price: '648.00',
      game: '太古封魔录2',
      server: '双线1服',
      role: '渣渣辉',
      product: '丧尸大礼包',
      zfbIcon: `${this.$cdnUrl}/tgStore/zfb.png`,
      wxIcon: `${this.$cdnUrl}/tgStore/wechat.png`,
      payType: [
      ],
      currentPayType: {},
      hintShow: false,
      order_sn: '',
      submitFlag: false
    };
  },
  computed: {
    ...mapState({
      userInfo: state => state.tgStore.userInfo,
      goodsInfo: state => state.tgStore.goodsInfo,  
      gameInfo: state => state.tgStore.gameInfo, 
    })
  },
  mounted() {
    if (!this.goodsInfo.name) this.$router.push({ name: 'tgStore.store', query: { config_id: this.$route.query.config_id,origin_id: this.$route.query.origin_id } });
    this.getPayType()
  },
  methods: {
    async getPayType() {
      const r = await payType({ config_id: this.$route.query.config_id });
      this.payType = r.data;
      this.currentPayType = this.payType.find(item => item.img_class_name == 'wechat');
    },
    async createOrder() {
      if (isWeiXin() && this.currentPayType.img_class_name == 'alipay') {
        this.hintShow = true;
        return;
      }
      if (this.submitFlag) return;
      this.submitFlag = true;
      if (isWeiXin()) {
        this.wxInnerPay();
      } else {
        this.outerPay();
      }
    },
    async wxInnerPay() {
      try {
        const orderInfo = await createOrder({ good_id: this.goodsInfo.id, pay_type: 52, config_id: this.$route.query.config_id })
        const { sy_order_sn, app_key, open_id, pay_url, check_url } = orderInfo.data;
        this.order_sn = sy_order_sn;
        const r = await officialAccountsPay(pay_url, {
          appkey: app_key,
          order_sn: sy_order_sn,
          wx_app_id: 'wxee4e6b906258b68e',
          open_id: open_id
        })
        const { nonceStr, paySign, timeStamp, signType } = r.content;
        wx.chooseWXPay({
          timestamp: timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
          nonceStr, // 支付签名随机串，不长于 32 位
          package: r.content.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
          signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
          paySign, // 支付签名
          success: res => {
            this.submitFlag = false;
            this.checkOrder(check_url);
          },
          fail: err => {
            this.submitFlag = false;
            this.checkOrder(check_url);
          },
          cancel: () => {
            this.submitFlag = false;
            this.checkOrder(check_url);
          }
        });
      } catch (error) {
        this.submitFlag = false;
        error.message && this.$toast(error.message);
      }
    },
    async outerPay() {
      try {
        const orderInfo = await createOrder({ good_id: this.goodsInfo.id, pay_type: this.currentPayType.pay_type, config_id: this.$route.query.config_id })
        const { sy_order_sn, app_key, pay_url } = orderInfo.data;
        this.order_sn = sy_order_sn;

        const sync_notify_url = window.location.href;
        const params = {
          appkey: app_key,
          order_sn: sy_order_sn,
          sync_notify_url: encodeURIComponent(sync_notify_url)
        };
        const sign = sort_ASCII(params).sign;
        const protocol = window.location.protocol;
        const fullPayUrl = pay_url.startsWith('//') ? `${protocol}${pay_url}` : pay_url;
        const aliUrl = `${fullPayUrl}?from_browser=1&appkey=${app_key}&order_sn=${sy_order_sn}&sign=${sign}&sync_notify_url=${encodeURIComponent(sync_notify_url)}`;
        window.open(aliUrl, '_self');
      } catch (error) {
        error.message && this.$toast(error.message);
        this.submitFlag = false;
      }
    },
    async checkOrder(check_url) {
      if (!check_url) {
        this.$toast('订单检查地址缺失');
        return;
      }
      const r = await checkOrderApi(check_url, { order_sn: this.order_sn });
      const { pay_status } = r.content;
      if (pay_status == 1) {
        this.$toast('支付成功，实际支付结果请以游戏内为准');
        this.$router.push({ name: 'tgStore.store', query: { config_id: this.$route.query.config_id,origin_id: this.$route.query.origin_id } });
      } else {
        this.$toast('支付失败，实际支付结果请以游戏内为准');
        this.$router.push({ name: 'tgStore.store', query: { config_id: this.$route.query.config_id,origin_id: this.$route.query.origin_id } });
      }
    }
  }
};
</script>

<style lang="scss" module>
.pay {
  > h1 {
    background: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    position: relative;
    padding: 10px 0;
    font-size: 18px;
    border-bottom: 1px solid #F6F6F6;
    margin-bottom: 10px;
    > img {
      position: absolute;
      left: 10px;
      width: 8px;
      height: 15px; 
    }
  }
  .price {
    text-align: center;
    font-size: 15px;
    font-weight: 400;
    text-align: center;
    color: #333333;
    padding-bottom: 43px;
    margin-bottom: 18px;
    position: relative;
    &::before {
      position: absolute;
      bottom: 0;
      left: 20px;
      right: 20px;
      content: ' ';
      height: 1px;
      background: #f6f6f6;
    }
    .priceNum {
      margin-top: 15px;
      font-size: 15px;
      > span {
        font-size: 29px;
      }
    }
  }
  .info {
    padding: 0 50px;
    color: #333333;
    font-size: 13px;
    font-weight: bold;
    position: relative;
    padding-bottom: 15px;
    &::before {
      position: absolute;
      bottom: 0;
      left: 20px;
      right: 20px;
      content: ' ';
      height: 1px;
      background: #f6f6f6;
    }
    > p {
      margin-bottom: 15px;
      > span {
        color: #666666;
      }
      .server {
        color: #5B98EC;
      }
      .product {
        color: #FF5959;
      }
    }
  }
  .payType {
    padding: 20px 40px;
    > p {
      margin-bottom: 10px;
    }
    > ul {
      > li {
        display: flex;
        align-items: center;
        position: relative;
        padding: 10px 0;
        .icon {
          width: 21px;
          height: 21px;
          margin-right: 12px;
        }
        .check {
          width: 13px;
          height: 13px;
          position: absolute;
          right: 0;
        }
      }
    }
  }
  .submit {
    display: block;
    margin: auto;
    width: 131.94px;
    height: 38.19px;
    background: #ff7a21;
    border-radius: 7px;
    color: #FFFFFF;
    border: none;
    &:active {
      opacity: 0.9;
    }
  }
  .hint {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 100;
    background-image: url('//static.hzwxbz3.cn/Lianyun/font_end/wap/offlinePay/tips.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
}
</style>
